var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { createAPI, getByIdAPI, getListAPI, setReducerState } from "../../../redux/crudSlice";
import { store } from "../../../store/store";
import { configurationGet, DelayReasonListAPI, getViewInvoiceURL, invoicedTabPaging, JCIFilterPagingAPI, JCIPostingTypes, jobCardInvoiceGeneralTabCustomerDetailsGet, jobCardInvoiceGeneralTabInvoiceDetailsLabourGet, jobCardInvoiceGeneralTabInvoiceDetailsPartsGet, jobCardInvoiceGeneralTabJobCardDetailsGet, jobCardInvoiceGeneralTabVehicleDetailsGet, JobCardInvoicesKeys, jobCardInvoiceUpsert, PaymentListAPI, paymentTermListURL, paymentTypeListURL, PostingTypeListAPI, readyForInvoiceAPIKeys, readyForInvoicePagingAPI, ServiceAdvisorListAPI } from "./entity";
import { getLoadingKey } from "../../../builderPackage/common/commonFunctions";
var dispatch = store.dispatch;
export var ReadyForInvoicePagingAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? readyForInvoiceAPIKeys.paging : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? readyForInvoicePagingAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload.value];
        }
    });
}); };
export var invoicedTabPagingTabAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardInvoicesKeys.InvoicedTabPaging : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? invoicedTabPaging : _c;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload.value];
        }
    });
}); };
export var configurationGetAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardInvoicesKeys.ConfigurationGet : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? configurationGet : _c;
                return [4 /*yield*/, dispatch(createAPI({
                        key: JobCardInvoicesKeys.ConfigurationGet,
                        url: configurationGet,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload.value];
        }
    });
}); };
export var jobCardInvoiceUpsertAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, JCIRequest, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardInvoicesKeys.JobCardInvoiceUpsert : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? jobCardInvoiceUpsert : _c;
                JCIRequest = _objectSpread(_objectSpread({}, request), {}, {
                    AccountPosting: [{
                            "AccountId": "f72ef56e-fa35-427c-a2aa-33ad6f6ef245",
                            "DebitAmount": 0,
                            "CreditAmount": 0
                        }],
                    ImageAttachments: [{
                            "AttachmentId": request === null || request === void 0 ? void 0 : request.attachmentId
                        }]
                });
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: jobCardInvoiceUpsert,
                        request: JCIRequest
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload.value];
        }
    });
}); };
export var getAggregatedTaxes = function () {
    var parts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var labours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var allTaxes = [];
    var extractTaxes = function (items) {
        items.forEach(function (item) {
            var _item$SavedPriceWithT;
            var taxes = (item === null || item === void 0 || (_item$SavedPriceWithT = item.SavedPriceWithTax) === null || _item$SavedPriceWithT === void 0 ? void 0 : _item$SavedPriceWithT.Taxes) || [];
            taxes.forEach(function (tax) {
                if (tax !== null && tax !== void 0 && tax.TaxComponentName) {
                    allTaxes.push({
                        TaxComponentName: tax.TaxComponentName,
                        TaxComponentPercentage: tax.TaxComponentPercentage || 0,
                        TaxComponentAmount: tax.TaxComponentAmount || 0
                    });
                }
            });
        });
    };
    extractTaxes(parts);
    extractTaxes(labours);
    var taxMap = new Map();
    allTaxes.forEach(function (_ref) {
        var TaxComponentName = _ref.TaxComponentName, TaxComponentPercentage = _ref.TaxComponentPercentage, TaxComponentAmount = _ref.TaxComponentAmount;
        var key = TaxComponentName;
        if (!taxMap.has(key)) {
            taxMap.set(key, {
                TaxComponentName: key,
                TaxComponentPercentage: 0,
                TaxComponentAmount: 0
            });
        }
        var existing = taxMap.get(key);
        taxMap.set(key, {
            TaxComponentName: key,
            TaxComponentPercentage: existing.TaxComponentPercentage + TaxComponentPercentage,
            TaxComponentAmount: existing.TaxComponentAmount + TaxComponentAmount
        });
    });
    return Array.from(taxMap.values());
};
export var jobCardInvoiceGeneralTabAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _jobCardRes$payload, _a, request, loaderKey, jobCardRes, _jobCardRes$payload2, _jobCardRes$payload3, _invoiceDetailsTabPar, _invoiceDetailsTabLab, _jobCardRes$payload4, _customerRes$payload, _vehicleDetails$paylo, _configurationApi$pay, _invoiceDetailsTabPar2, _invoiceDetailsTabLab2, _b, customerRes, vehicleDetails, invoiceDetailsTabParts, invoiceDetailsTabLabour, configurationApi, parts, labours, calc_1, aggregatedTaxes, response;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = params.request, request = _a === void 0 ? {} : _a;
                loaderKey = getLoadingKey(JobCardInvoicesKeys.GeneralTabJobCardDetails);
                dispatch(setReducerState({
                    key: loaderKey,
                    value: 'loading'
                }));
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: JobCardInvoicesKeys.GeneralTabJobCardDetails,
                        url: jobCardInvoiceGeneralTabJobCardDetailsGet(request === null || request === void 0 ? void 0 : request.JobCardId),
                        request: request
                    }))];
            case 1:
                jobCardRes = _c.sent();
                if (!(jobCardRes !== null && jobCardRes !== void 0 && (_jobCardRes$payload = jobCardRes.payload) !== null && _jobCardRes$payload !== void 0 && (_jobCardRes$payload = _jobCardRes$payload.value) !== null && _jobCardRes$payload !== void 0 && (_jobCardRes$payload = _jobCardRes$payload.data) !== null && _jobCardRes$payload !== void 0 && _jobCardRes$payload.CustomerId)) return [3 /*break*/, 3];
                return [4 /*yield*/, Promise.all([dispatch(getByIdAPI({
                            key: JobCardInvoicesKeys.GeneralTabCustomerDetails,
                            url: jobCardInvoiceGeneralTabCustomerDetailsGet(jobCardRes === null || jobCardRes === void 0 || (_jobCardRes$payload2 = jobCardRes.payload) === null || _jobCardRes$payload2 === void 0 || (_jobCardRes$payload2 = _jobCardRes$payload2.value) === null || _jobCardRes$payload2 === void 0 || (_jobCardRes$payload2 = _jobCardRes$payload2.data) === null || _jobCardRes$payload2 === void 0 ? void 0 : _jobCardRes$payload2.CustomerId),
                            request: {}
                        })), dispatch(getByIdAPI({
                            key: JobCardInvoicesKeys.GeneralTabJobVehicleDetails,
                            url: jobCardInvoiceGeneralTabVehicleDetailsGet(jobCardRes === null || jobCardRes === void 0 || (_jobCardRes$payload3 = jobCardRes.payload) === null || _jobCardRes$payload3 === void 0 || (_jobCardRes$payload3 = _jobCardRes$payload3.value) === null || _jobCardRes$payload3 === void 0 || (_jobCardRes$payload3 = _jobCardRes$payload3.data) === null || _jobCardRes$payload3 === void 0 ? void 0 : _jobCardRes$payload3.InstallBaseId),
                            request: {}
                        })), dispatch(createAPI({
                            key: JobCardInvoicesKeys.GeneralTabInvoiceDetailsParts,
                            url: jobCardInvoiceGeneralTabInvoiceDetailsPartsGet(),
                            request: request
                        })), dispatch(createAPI({
                            key: JobCardInvoicesKeys.GeneralTabInvoiceDetailsLabour,
                            url: jobCardInvoiceGeneralTabInvoiceDetailsLabourGet(),
                            request: request
                        })), dispatch(createAPI({
                            key: JobCardInvoicesKeys.ConfigurationGet,
                            url: configurationGet,
                            request: {
                                Key: "invoiceConfiguration"
                            }
                        }))])];
            case 2:
                _b = _c.sent(), customerRes = _b[0], vehicleDetails = _b[1], invoiceDetailsTabParts = _b[2], invoiceDetailsTabLabour = _b[3], configurationApi = _b[4];
                parts = invoiceDetailsTabParts === null || invoiceDetailsTabParts === void 0 || (_invoiceDetailsTabPar = invoiceDetailsTabParts.payload) === null || _invoiceDetailsTabPar === void 0 || (_invoiceDetailsTabPar = _invoiceDetailsTabPar.value) === null || _invoiceDetailsTabPar === void 0 ? void 0 : _invoiceDetailsTabPar.data;
                labours = invoiceDetailsTabLabour === null || invoiceDetailsTabLabour === void 0 || (_invoiceDetailsTabLab = invoiceDetailsTabLabour.payload) === null || _invoiceDetailsTabLab === void 0 || (_invoiceDetailsTabLab = _invoiceDetailsTabLab.value) === null || _invoiceDetailsTabLab === void 0 ? void 0 : _invoiceDetailsTabLab.data;
                calc_1 = {
                    PaidAmount: 0,
                    ExpenseAmount: 0,
                    ClaimAmount: 0,
                    GrandTotal: 0,
                    SubTotal: 0
                };
                parts === null || parts === void 0 || parts.forEach(function (item) {
                    var _item$SavedPriceWithT2, _item$SavedPriceWithT3, _item$SavedPriceWithT4, _item$SavedPriceWithT5;
                    var amount = (_item$SavedPriceWithT2 = item === null || item === void 0 || (_item$SavedPriceWithT3 = item.SavedPriceWithTax) === null || _item$SavedPriceWithT3 === void 0 ? void 0 : _item$SavedPriceWithT3.Amount) !== null && _item$SavedPriceWithT2 !== void 0 ? _item$SavedPriceWithT2 : 0;
                    var taxableAmount = (_item$SavedPriceWithT4 = item === null || item === void 0 || (_item$SavedPriceWithT5 = item.SavedPriceWithTax) === null || _item$SavedPriceWithT5 === void 0 ? void 0 : _item$SavedPriceWithT5.TaxableAmount) !== null && _item$SavedPriceWithT4 !== void 0 ? _item$SavedPriceWithT4 : 0;
                    if ((item === null || item === void 0 ? void 0 : item.PostingTypeName) === JCIPostingTypes.Expenses) {
                        calc_1.ExpenseAmount += amount;
                    }
                    if ((item === null || item === void 0 ? void 0 : item.PostingTypeName) === JCIPostingTypes.Paid) {
                        calc_1.PaidAmount += amount;
                    }
                    if ((item === null || item === void 0 ? void 0 : item.PostingTypeName) === JCIPostingTypes.Claims) {
                        calc_1.ClaimAmount += amount;
                    }
                    calc_1.SubTotal += taxableAmount;
                });
                labours === null || labours === void 0 || labours.forEach(function (item) {
                    var _item$SavedPriceWithT6, _item$SavedPriceWithT7, _item$SavedPriceWithT8, _item$SavedPriceWithT9;
                    var amount = (_item$SavedPriceWithT6 = item === null || item === void 0 || (_item$SavedPriceWithT7 = item.SavedPriceWithTax) === null || _item$SavedPriceWithT7 === void 0 ? void 0 : _item$SavedPriceWithT7.Amount) !== null && _item$SavedPriceWithT6 !== void 0 ? _item$SavedPriceWithT6 : 0;
                    var taxableAmount = (_item$SavedPriceWithT8 = item === null || item === void 0 || (_item$SavedPriceWithT9 = item.SavedPriceWithTax) === null || _item$SavedPriceWithT9 === void 0 ? void 0 : _item$SavedPriceWithT9.TaxableAmount) !== null && _item$SavedPriceWithT8 !== void 0 ? _item$SavedPriceWithT8 : 0;
                    if ((item === null || item === void 0 ? void 0 : item.PostingTypeName) === JCIPostingTypes.Expenses) {
                        calc_1.ExpenseAmount += amount;
                    }
                    if ((item === null || item === void 0 ? void 0 : item.PostingTypeName) === JCIPostingTypes.Paid) {
                        calc_1.PaidAmount += amount;
                    }
                    if ((item === null || item === void 0 ? void 0 : item.PostingTypeName) === JCIPostingTypes.Claims) {
                        calc_1.ClaimAmount += amount;
                    }
                    calc_1.SubTotal += taxableAmount;
                });
                calc_1.GrandTotal = calc_1.ExpenseAmount + calc_1.ClaimAmount + calc_1.PaidAmount;
                aggregatedTaxes = getAggregatedTaxes(parts, labours);
                response = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, jobCardRes === null || jobCardRes === void 0 || (_jobCardRes$payload4 = jobCardRes.payload) === null || _jobCardRes$payload4 === void 0 || (_jobCardRes$payload4 = _jobCardRes$payload4.value) === null || _jobCardRes$payload4 === void 0 ? void 0 : _jobCardRes$payload4.data), customerRes === null || customerRes === void 0 || (_customerRes$payload = customerRes.payload) === null || _customerRes$payload === void 0 || (_customerRes$payload = _customerRes$payload.value) === null || _customerRes$payload === void 0 ? void 0 : _customerRes$payload.data), vehicleDetails === null || vehicleDetails === void 0 || (_vehicleDetails$paylo = vehicleDetails.payload) === null || _vehicleDetails$paylo === void 0 || (_vehicleDetails$paylo = _vehicleDetails$paylo.value) === null || _vehicleDetails$paylo === void 0 ? void 0 : _vehicleDetails$paylo.data), {}, {
                    DynamicValues: configurationApi === null || configurationApi === void 0 || (_configurationApi$pay = configurationApi.payload) === null || _configurationApi$pay === void 0 || (_configurationApi$pay = _configurationApi$pay.value) === null || _configurationApi$pay === void 0 || (_configurationApi$pay = _configurationApi$pay.data) === null || _configurationApi$pay === void 0 ? void 0 : _configurationApi$pay.DynamicValues,
                    Parts: invoiceDetailsTabParts === null || invoiceDetailsTabParts === void 0 || (_invoiceDetailsTabPar2 = invoiceDetailsTabParts.payload) === null || _invoiceDetailsTabPar2 === void 0 || (_invoiceDetailsTabPar2 = _invoiceDetailsTabPar2.value) === null || _invoiceDetailsTabPar2 === void 0 ? void 0 : _invoiceDetailsTabPar2.data,
                    Labours: invoiceDetailsTabLabour === null || invoiceDetailsTabLabour === void 0 || (_invoiceDetailsTabLab2 = invoiceDetailsTabLabour.payload) === null || _invoiceDetailsTabLab2 === void 0 || (_invoiceDetailsTabLab2 = _invoiceDetailsTabLab2.value) === null || _invoiceDetailsTabLab2 === void 0 ? void 0 : _invoiceDetailsTabLab2.data
                }, calc_1), {}, {
                    SelectedButton: JCIPostingTypes.Paid,
                    JobCardInvoiceGrandTotal: calc_1.GrandTotal,
                    Tax: aggregatedTaxes
                });
                dispatch(setReducerState({
                    key: loaderKey,
                    value: 'idle'
                }));
                console.log("response---------------->", response);
                return [2 /*return*/, {
                        success: true,
                        data: response,
                        statusCode: 200
                    }];
            case 3:
                dispatch(setReducerState({
                    key: loaderKey,
                    value: 'idle'
                }));
                return [2 /*return*/, {
                        success: false
                    }];
        }
    });
}); };
export var paymentTypeListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardInvoicesKeys.PaymentTypeListKey : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? paymentTypeListURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 ? void 0 : _res$payload.value];
        }
    });
}); };
export var paymentTermListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload2, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardInvoicesKeys.PaymentTermListKey : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? paymentTermListURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.value];
        }
    });
}); };
export var getViewInvoiceDetails = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload3, _res$payload5, _res$payload6, _res$payload7, _custRes$payload, _vehicleRes, _a, request, vehicleRes, res, custRes, _res$payload4, response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = params.request, request = _a === void 0 ? {} : _a;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: JobCardInvoicesKeys === null || JobCardInvoicesKeys === void 0 ? void 0 : JobCardInvoicesKeys.ViewInvoiceDetails,
                        url: getViewInvoiceURL(request === null || request === void 0 ? void 0 : request.id),
                        request: {}
                    }))];
            case 1:
                res = _b.sent();
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: JobCardInvoicesKeys.CustomerInfo,
                        url: jobCardInvoiceGeneralTabCustomerDetailsGet(request === null || request === void 0 ? void 0 : request.CustomerId),
                        request: {}
                    }))];
            case 2:
                custRes = _b.sent();
                if (!(res !== null && res !== void 0 && (_res$payload3 = res.payload) !== null && _res$payload3 !== void 0 && (_res$payload3 = _res$payload3.value) !== null && _res$payload3 !== void 0 && (_res$payload3 = _res$payload3.data) !== null && _res$payload3 !== void 0 && _res$payload3.InstallBaseId)) return [3 /*break*/, 4];
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: JobCardInvoicesKeys.installbaseData,
                        url: jobCardInvoiceGeneralTabVehicleDetailsGet(res === null || res === void 0 || (_res$payload4 = res.payload) === null || _res$payload4 === void 0 || (_res$payload4 = _res$payload4.value) === null || _res$payload4 === void 0 || (_res$payload4 = _res$payload4.data) === null || _res$payload4 === void 0 ? void 0 : _res$payload4.InstallBaseId),
                        request: {}
                    }))];
            case 3:
                vehicleRes = _b.sent();
                _b.label = 4;
            case 4:
                response = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, res === null || res === void 0 || (_res$payload5 = res.payload) === null || _res$payload5 === void 0 || (_res$payload5 = _res$payload5.value) === null || _res$payload5 === void 0 ? void 0 : _res$payload5.data), res === null || res === void 0 || (_res$payload6 = res.payload) === null || _res$payload6 === void 0 || (_res$payload6 = _res$payload6.value) === null || _res$payload6 === void 0 || (_res$payload6 = _res$payload6.data) === null || _res$payload6 === void 0 ? void 0 : _res$payload6.InvoiceDetails), res === null || res === void 0 || (_res$payload7 = res.payload) === null || _res$payload7 === void 0 || (_res$payload7 = _res$payload7.value) === null || _res$payload7 === void 0 || (_res$payload7 = _res$payload7.data) === null || _res$payload7 === void 0 ? void 0 : _res$payload7.InvoiceSummary), custRes === null || custRes === void 0 || (_custRes$payload = custRes.payload) === null || _custRes$payload === void 0 || (_custRes$payload = _custRes$payload.value) === null || _custRes$payload === void 0 ? void 0 : _custRes$payload.data), (_vehicleRes = vehicleRes) === null || _vehicleRes === void 0 || (_vehicleRes = _vehicleRes.payload) === null || _vehicleRes === void 0 || (_vehicleRes = _vehicleRes.value) === null || _vehicleRes === void 0 ? void 0 : _vehicleRes.data), {}, {
                    SelectedButton: JCIPostingTypes.Paid
                });
                return [2 /*return*/, {
                        data: response,
                        success: true
                    }];
        }
    });
}); };
export var delayReasonListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload8, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardInvoicesKeys.DelayReasonListKeys : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? DelayReasonListAPI : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload8 = res.payload) === null || _res$payload8 === void 0 ? void 0 : _res$payload8.value];
        }
    });
}); };
export var postingTypeListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload9, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardInvoicesKeys.PostingTypeListKeys : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? PostingTypeListAPI : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload9 = res.payload) === null || _res$payload9 === void 0 ? void 0 : _res$payload9.value];
        }
    });
}); };
export var serviceAdvisorListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload10, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardInvoicesKeys.ServiceAdvisorList : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? ServiceAdvisorListAPI : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload10 = res.payload) === null || _res$payload10 === void 0 ? void 0 : _res$payload10.value];
        }
    });
}); };
export var jciFilterPagingAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload11, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardInvoicesKeys.JCIFilterPagingKey : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? JCIFilterPagingAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload11 = res.payload) === null || _res$payload11 === void 0 ? void 0 : _res$payload11.value];
        }
    });
}); };
export var jciReadyForInvoiceCountAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload12, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardInvoicesKeys.ReadyForInvoiceCount : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? JCIFilterPagingAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload12 = res.payload) === null || _res$payload12 === void 0 ? void 0 : _res$payload12.value];
        }
    });
}); };
export var jciInvoiceCountAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload13, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardInvoicesKeys.InvoiceCount : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? JCIFilterPagingAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload13 = res.payload) === null || _res$payload13 === void 0 ? void 0 : _res$payload13.value];
        }
    });
}); };
export var paymentModeListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload14, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? JobCardInvoicesKeys.PaymentMode : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? PaymentListAPI : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload14 = res.payload) === null || _res$payload14 === void 0 ? void 0 : _res$payload14.value];
        }
    });
}); };
